import { render } from "./TabPull.vue?vue&type=template&id=091bacbc"
import script from "./TabPull.vue?vue&type=script&setup=true&lang=js"
export * from "./TabPull.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ui/StreamSidebar/TabPull.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "091bacbc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('091bacbc', __exports__)) {
    api.reload('091bacbc', __exports__)
  }
  
  module.hot.accept("./TabPull.vue?vue&type=template&id=091bacbc", () => {
    api.rerender('091bacbc', render)
  })

}


export default __exports__